import React from 'react'
import { Box, styled, Typography } from '@mui/material'

// eslint-disable-next-line import/no-cycle
import { DynamicInputForm, FormProps } from '../DynamicInputForm-deprecated'
import { ThemeProvider } from '../../theme'

export type SignupBlockProps = {
  data: {
    title: string
    description: {
      children: {
        text: string
      }[]
    }[]
    form_input_single_row: FormProps['formProps']
  }
}

const Form = styled(Box)`
  ${({ theme }) => `
    form {
      input {
        height: 40px;
        background-color: ${theme.palette.text.primary};
        color: ${theme.palette.background.default};
        padding: 0 ${theme.spacing(2)};
      }

      button {
        background: transparent;
        border: 1px solid ${theme.palette.text.primary};
        color: ${theme.palette.text.primary};
        font-size: 14px;
        line-height: 1.5;
        padding: ${theme.spacing(1)};

        :hover {
          background: transparent;
        }

        &.Mui-disabled {
          background: ${theme.palette.text.primary};
          color: ${theme.palette.background.default};
          margin-left: 0;
          margin-top: 0;
        }
      }
    }

    h6 {
      margin-top: ${theme.spacing(0.5)};
    }
  `}
`

export const SignupBlock = ({ data }: SignupBlockProps) => (
  <ThemeProvider mode='dark'>
    <Box
      sx={{
        bgcolor: 'primary.main',
        borderRadius: 3,
        mt: { xs: 3.5, tablet: 5 },
        px: { xs: 2.5, tablet: 5 },
        py: { xs: 3.5, tablet: 5 },
      }}>
      <Typography
        variant='h6'
        sx={{ fontSize: 24, fontWeight: 'bold', lineHeight: 1.2 }}>
        {data.title}
      </Typography>
      <Typography sx={{ mt: 2 }}>
        {data.description[0].children[0].text}
      </Typography>

      <Form sx={{ mt: { xs: 3, tablet: 2.5 } }}>
        <DynamicInputForm
          formProps={data.form_input_single_row}
          singleFieldForm
          errorAfterButton
          sx={{
            display: { mobile: 'flex' },
            '.MuiInputBase-root': {
              minWidth: { mobile: '50%', laptop: '0%' },
            },
            button: {
              ml: { mobile: 4 },
              mt: { mobile: 0 },
            },
          }}
        />
      </Form>
    </Box>
  </ThemeProvider>
)
